import { withRouter } from 'react-router-dom'
import { TabsHead as TabsHeadComponent } from './TabsHead'

export const TabsHead = withRouter(TabsHeadComponent)
